import { apiService } from './apiService';

export const vehicleAssignmentFormService = {
  async getAll() {
    return apiService.get('/vehicle-assignment-forms');
  },
  async getById(id: string | number) {
    return apiService.get(`/vehicle-assignment-forms/${id}`);
  },
  async create(data: any) {
    return apiService.post('/vehicle-assignment-forms', data);
  },
  async update(id: string | number, data: any) {
    return apiService.put(`/vehicle-assignment-forms/${id}`, data);
  },
  async delete(id: string | number) {
    return apiService.delete(`/vehicle-assignment-forms/${id}`);
  },
  async downloadPrintPdf(id: string | number) {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${baseUrl}/vehicle-assignment-forms/${id}/print-pdf`, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    if (!response.ok) {
      let message = 'PDF indirilemedi';
      try {
        const data = await response.json();
        message = data.message || message;
      } catch {
        // ignore parse error
      }
      throw new Error(message);
    }
    return response.blob();
  },
};
